import React from 'react'
import { Popup } from 'camino-react'
import _ from 'lodash'

import humanizeString from 'humanize-string'

const Legend = ({ events }) => (
  <Popup
    on="hover"
    contentStyle={{ whiteSpace: 'pre-wrap', width: 'auto', zIndex: 9 }}
    trigger={<span className="link" style={{ float: 'right' }}>Legend</span>}
  >
    <div>
      {_.map(events, event => (
        <div className="rbc-calendar-legend" style={{ backgroundColor: event.meta.color }}>{humanizeString(event.meta.klass_name)}</div>
      ))}
      <div className="rbc-calendar-legend" style={{ backgroundColor: '#00BAEA' }}>Ticket task</div>
    </div>
  </Popup>
)

export default Legend
